import { CurrencyField, TextField, useFieldHelper } from 'framework/ui/field';
import { ControlledList, DataGridLayout } from 'framework/list';
import { LedgerLink } from 'domain/shared/ledger';
import JournalEntryTransferField from 'domain/finance/journalEntry/shared/field/JournalEntryTransferField';

const JournalEntryTransfersList = ({ source }: { source: string }) => {
  const { getValue } = useFieldHelper({ source });
  const transfers = (getValue() as any) || [];

  return (
    <ControlledList data={{ items: transfers, totalPages: 1, totalElements: transfers.length }}>
      <DataGridLayout
        sxTableWrapper={{
          '& table.MuiTable-root': {
            minWidth: '1080px',
          },
        }}
      >
        <LedgerLink source="accountId" nameSource="accountId" dateSource="asDateOf" label="Account" width="25%" />
        <JournalEntryTransferField source="id" label="Transfer ID" width="20%" />
        <CurrencyField source="debit" currencySource="currency" label="Debit" width="20%" emptyValue=" " />
        <CurrencyField source="credit" currencySource="currency" label="Credit" width="20%" emptyValue=" " />
        <TextField source="description" label="Description" width="25%" />
      </DataGridLayout>
    </ControlledList>
  );
};

export default JournalEntryTransfersList;
